__turbopack_context__.v({
  "animatedHeart": "FavoriteButton-module-scss-module__aGLGJW__animatedHeart",
  "count": "FavoriteButton-module-scss-module__aGLGJW__count",
  "disabled": "FavoriteButton-module-scss-module__aGLGJW__disabled",
  "favoriteButton": "FavoriteButton-module-scss-module__aGLGJW__favoriteButton",
  "favoriteButtonContainer": "FavoriteButton-module-scss-module__aGLGJW__favoriteButtonContainer",
  "favorited": "FavoriteButton-module-scss-module__aGLGJW__favorited",
  "heart": "FavoriteButton-module-scss-module__aGLGJW__heart",
  "heart-beat": "FavoriteButton-module-scss-module__aGLGJW__heart-beat",
  "heart-float": "FavoriteButton-module-scss-module__aGLGJW__heart-float",
  "heartIcon": "FavoriteButton-module-scss-module__aGLGJW__heartIcon",
  "icon": "FavoriteButton-module-scss-module__aGLGJW__icon",
  "initialized": "FavoriteButton-module-scss-module__aGLGJW__initialized",
  "loading": "FavoriteButton-module-scss-module__aGLGJW__loading",
  "size-large": "FavoriteButton-module-scss-module__aGLGJW__size-large",
  "spin": "FavoriteButton-module-scss-module__aGLGJW__spin",
  "spinner": "FavoriteButton-module-scss-module__aGLGJW__spinner",
  "variant-default": "FavoriteButton-module-scss-module__aGLGJW__variant-default",
});
